export default {"src":"/_next/static/media/hamburger-menu-icon.505cc287.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};